import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18RightsG = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey300,
      fillRule: "evenodd",
      d: "M15.808 2.161c-1.57-1.548-4.287-1.548-5.856 0a4.02 4.02 0 0 0-1.22 2.882c0 .803.232 1.563.668 2.208l-7.15 7.068a.865.865 0 0 0 .611 1.476c.218 0 .45-.086.61-.258l.407-.401 1.7 1.677a.87.87 0 0 0 .61.258.84.84 0 0 0 .61-.258.864.864 0 0 0 0-1.218l-1.685-1.678.829-.817 1.7 1.678c.16.172.392.258.61.258s.45-.086.61-.258a.87.87 0 0 0 0-1.22l-1.685-1.662 3.458-3.412a4.15 4.15 0 0 0 5.158-.53A4.02 4.02 0 0 0 17 5.056a3.94 3.94 0 0 0-1.192-2.896zm-1.235 4.56c-.901.888-2.485.888-3.386 0a2.35 2.35 0 0 1 0-3.341c.916-.889 2.485-.889 3.386 0 .93.917.93 2.423 0 3.34z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18RightsG$1 = Svg18RightsG;

export { Svg18RightsG$1 as default };
